import React, {useState} from 'react'
import {NavLink, Route, Router, Switch, Redirect} from "react-router-dom";
import AdminLanguages from "./AdminLanguages/AdminLanguages";
import AdminTranslations from "./AdminTranslations/AdminTranslations";
import AdminTranslationTokens from "./AdminTranslationTokens/AdminTranslationTokens";
import AdminViewTranslation from "./AdminTranslations/AdminViewTranslation";
import Layout from "~/Admin/Layout/Layout";
import TopMenu from '../Layout/TopMenu/TopMenu';

const AdminMultilang = ({match, ...props}) => {

    return (
        <Layout>

            <h1>Multi Lingual</h1>

            <TopMenu>
                <NavLink
                    exact
                    activeClassName="active"
                    to={`${match.path}`}>
                    Translations
                </NavLink>
                <NavLink
                    exact
                    activeClassName="active"
                    to={`${match.path}/languages`}>
                    Languages
                </NavLink>
                <NavLink
                    exact
                    activeClassName="active"
                    to={`${match.path}/tokens`}>
                    Translation Tokens
                </NavLink>
            </TopMenu>

            <div className="content mt-5">
                <Route exact path={`${match.path}/`} component={AdminTranslations} />
                <Route exact path={`${match.path}/view/:id(\\d+)`} component={AdminViewTranslation} />
                <Route exact path={`${match.path}/languages`} component={AdminLanguages} />
                <Route exact path={`${match.path}/tokens`} component={AdminTranslationTokens} />
            </div>

        </Layout>
    );
}

export default AdminMultilang;
